import TemplateView from '../../TemplateView'
import Link from '../../components/Link'
import Button from '../../components/Button'
import messageResource from '../../messageResource'

export default class AddonCard extends TemplateView {
    constructor({
        additionalIconClass = '',
        titleTextKey = '',
        titleLink = '',
        descriptionTextKey = '',
        showActionButton = true,
        actionButtonTextKey = '',
        actionNotAvailable = false,
        onActionButtonClick = () => {},
        onDetailsButtonClick = () => {},
        notAvailableButtonTextKey = '',
        customButtonComponent = null,
        onLinkClickCallback = () => {},
    } = {}) {
        super()

        this.params = {
            additionalIconClass,
            titleTextKey,
            titleLink,
            descriptionTextKey,
            notAvailableButtonTextKey,
            customButtonComponent: customButtonComponent || new Button({
                label: messageResource.getMessage(actionButtonTextKey),
                onClickCb: onActionButtonClick,
            }),
        }

        this.callbacks = {
            onDetailsButtonClick,
            onLinkClickCallback,
        }

        this.state = {
            showWarning: false,
            isExpired: false,

            showActionButton,
            actionNotAvailable,
        }

        this.onStatePropertyChanged('showWarning', (showWarning) => this.$warning.toggle(showWarning))
        this.onStatePropertyChanged('isExpired', (isExpired) => {
            this.$expiredNote.toggle(isExpired)
            this.$violatedNote.toggle(!isExpired)
            this.$warningDetailsButton.toggle(isExpired)
        })

        this.onAnyStatePropertyChanged(['showActionButton', 'actionNotAvailable'], () => {
            this.$actionButton.toggle(this.state.showActionButton && !this.state.actionNotAvailable)
            this.$notAvailableButton.toggle(this.state.actionNotAvailable)
        })
    }

    templateHtml() {
        return `<div class='addonCard'>
                    <div class='firstColumn'>
                        <div class='cardIcon <%-additionalIconClass%>'/>
                        <div class='warning'>
                            <div class='icon'/>
                            <div class='expiredNote'><%=expiredNote%></div>
                            <div class='violatedNote'><%=violatedNote%></div>
                            <div class='detailsButton'><%=detailsButton%></div>
                        </div>
                    </div>
                    <div class='secondColumn'>
                        <div class='content'>
                            <div class='header'/>
                            <div class='description'><%-descriptionText%></div>                        
                        </div>
                        <div class='footer'>
                            <div class='actionButton'/>
                            <div class='notAvailableButton'/>
                        </div>
                    </div>
                </div>`
    }

    templateModel() {
        return {
            additionalIconClass: this.params.additionalIconClass,
        }
    }

    messageKeys() {
        return {
            expiredNote: 'menu.addons.license_expired_warning',
            violatedNote: 'menu.addons.license_violated_warning',
            detailsButton: 'menu.addons.view_warning_details.button',
            descriptionText: this.params.descriptionTextKey,
        }
    }

    afterRender() {
        this.$warning = this.find('.warning')
        this.$expiredNote = this.find('.expiredNote')
        this.$violatedNote = this.find('.violatedNote')
        this.$warningDetailsButton = this.find('.detailsButton')
        this.$warningDetailsButton.on('click', this.callbacks.onDetailsButtonClick)
        new Link({
            text: messageResource.getMessage(this.params.titleTextKey),
            reference: this.params.titleLink,
            onClickCallback: this.callbacks.onLinkClickCallback
        }).init(this.find('.header'))

        this.$actionButton = this.find('.actionButton')
        this.$notAvailableButton = this.find('.notAvailableButton')
        this.params.customButtonComponent.init(this.$actionButton)
        this.$notAvailableButton.text(this.params.notAvailableButtonTextKey ? messageResource.getMessage(this.params.notAvailableButtonTextKey) : '')

        this.renderInitialState()
    }
}



// WEBPACK FOOTER //
// ./web/js/support/addons/AddonCard.js